export const CONTRACT_STATUS_COLORS = {
  sent: "gold",
  bidding: "cyan",
  awarded: "purple",
  accepted: "blue",
  pending_acceptance: "green",
  cancelled: "volcano",
  closed: "default",
};

export const CONTRACT_STATUS_LABELS = {
  sent: "Sent",
  bidding: "Bidding",
  awarded: "Awarded",
  accepted: "Accepted",
  pending_acceptance: "Pending Acceptance",
  cancelled: "Cancelled",
  closed: "Closed",
};

export const CONTRACT_PRIORITIES = ["Urgent", "Important", "Low"];

export const CONTRACT_STATUS_OPTIONS = [
  { value: "sent", label: "Sent" },
  { value: "bidding", label: "Bidding" },
  { value: "awarded", label: "Awarded" },
  { value: "accepted", label: "Accepted" },
  { value: "pending_acceptance", label: "Pending Acceptance" },
  { value: "cancelled", label: "Cancelled" },
  { value: "closed", label: "Closed" },
];

// Full lifecycle shown to the facility/portfolio side.
export const CONTRACT_STEPS = [
  { key: "sent", label: "Sent" },
  { key: "bidding", label: "Bidding" },
  { key: "awarded", label: "Awarded" },
  { key: "accepted", label: "Accepted" },
  { key: "pending_acceptance", label: "Pending Acceptance" },
  { key: "closed", label: "Closed" },
];

// A cancelled request is a terminal branch shown on its own.
export const CONTRACT_CANCELLED_STEPS = [
  { key: "cancelled", label: "Cancelled" },
];

// Resolve the step list to render for a given display status.
export const getContractSteps = (displayStatus) => {
  if (displayStatus === "cancelled") {
    return CONTRACT_CANCELLED_STEPS;
  }
  return CONTRACT_STEPS;
};

// Pick the display status for a contract record: prefer the backend-computed
// value, fall back to the raw status.
export const getDisplayStatus = (record) =>
  record?.display_status || record?.status || "sent";

// Resolve the human-readable label for a record's display status.
export const getDisplayStatusLabel = (record) =>
  record?.display_status_label ||
  CONTRACT_STATUS_LABELS[getDisplayStatus(record)] ||
  getDisplayStatus(record);

export const normalizeContractResponse = (response) => {
  const payload = response?.data || {};
  if (Array.isArray(payload)) {
    return { rows: payload, total: payload.length };
  }
  return {
    rows: payload.results || [],
    total: payload.count || 0,
  };
};
